// (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
var _ = require('lodash');
import { GET_SUBSCRIPTION_HISTORY, SAVE_TWIG_IN_SESSION, CONFIRM_CANCELLATION, CLOSE_CONFIRMATION } from '../actions/actions';
import constants from '../Constants';
import {
  filterChart, getFromSession, saveInSession, loadTwigDataBasedonPreference,
  convertDate, getInitialFromDate, getSelectedTwigDetails
} from '../utils/Utility';
const initialState = {
    subscriptionDetails : null,
    unsubscribedTwigs: null,
    subscriptions: null,
    modifyTwigSubscription: null,
    twig: null,
    isSubscribed: null,
    showCancellationDialog: false,
    subscriptionToCancel : null,
    subscribedTwigs: null
};
const handlers = {
    [GET_SUBSCRIPTION_HISTORY] :(state, action) => {
        let unsubscribedTwigs;
        let subscribedTwigs =[];
        if(action && action.result && action.result.twigs) {
            action.result.twigs.data.forEach((twig,index) => {
                twig.twigIndex = index;
            });
            if(!action.result.data.subscriptions && !action.result.data.subscriptions.length) {
                unsubscribedTwigs = action.result.twigs.data;
            }
            else {
                _.forEach(action.result.data.subscriptions, subscription =>{
                    _.remove(action.result.twigs.data, (twig, index)=> {
                        if(twig.twigId === subscription.twigId){
                            subscription.twigIndex = twig.twigIndex;
                            subscription.twigName = twig.name;
                            return twig;
                        }
                    });
                });
                unsubscribedTwigs = action.result.twigs.data;
            }
            return  {
                unsubscribedTwigs,
                subscriptionDetails : action.result.data.subscriptionHistory,
                subscribedTwigs : action.result.data.subscriptions
            }
        }
    },

    [SAVE_TWIG_IN_SESSION]: (state, action) => {
        saveInSession('twigToSubscribe', action.result)
        return  {
            twig: action.result.twig,
            subscriptionSelected : action.result.subscriptionSelected
        }
    },

    [CONFIRM_CANCELLATION] : (state, action) => {
        return  {
            subscriptionToCancel : action.result.data,
            showCancellationDialog: action.result.success
        }
    },

    [CLOSE_CONFIRMATION] : (state, action) => {
        return  {
            showCancellationDialog: action.result
        }
    }
};

export default function subscriptionViewReducer(state = initialState, action) {
    
      let handler = handlers[action.type];
      if (!handler) return state;
      let newState = _.cloneDeep(state);
      return { ...newState, ...handler(newState, action) };
    }


// WEBPACK FOOTER //
// ./src/js/reducers/subscriptionView.js